<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2024-03-06 09:46:13
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 13:53:20
 * @Description: description
-->
<template>
  <common-dialog
    width="90%"
    top="5vh"
    title="预览"
    modal-append-to-body
    append-to-body
    :visible.sync="showPreview"
    :before-close="handleCancelClick"
  >
    <Preview
      v-if="showPreview"
      style="height: calc(100vh - 278px)"
      :preViewObj="preViewObj"
    >
    </Preview>
    <span slot="footer" class="dialog-footer">
      <common-button type="cancel" image size="small" @click="handleCancelClick"
        >取 消
      </common-button>
      <common-button
        type="primary"
        image
        size="small"
        @click="handleView(preViewObj)"
        >下 载
      </common-button>
    </span>
  </common-dialog>
</template>

<script>
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import { ATTA_FILE_DOWN_TYPE } from "@/constants/constants";
export default {
  components: {},
  props: {
    // 文件uuid
    preViewObj: {
      type: Object | File,
      default: () => {}
    },
    showPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isdocx: false,
      isexcel: false,
      ispdf: false
    };
  },
  mounted() {},
  methods: {
    //准备需要查看的附件的链接,然后显示或者下载附件
    handleView(item) {
      let fileType = item.attachmentOriginalName.substring(
        item.attachmentOriginalName.lastIndexOf(".") + 1
      );
      const elink = document.createElement("a");
      http
        .get(
          window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code,
          { responseType: "blob" }
        )
        .then(response => {
          if (response) {
            let attaFileDownTypeElement = ATTA_FILE_DOWN_TYPE[fileType];
            elink.download = item.attachmentOriginalName.substring(
              0,
              item.attachmentOriginalName.lastIndexOf(".")
            );
            elink.style.display = "none";
            elink.target = "_blank";
            elink.href = URL.createObjectURL(
              new Blob([response.data], { type: attaFileDownTypeElement })
            );
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCancelClick() {
      this.$emit("handleClosePreview", false);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-dialog__wrapper {
}
</style>



// WEBPACK FOOTER //
// src/components/common/DialogPreview.vue